import { React } from '@digsup/core-ui';
import { Icon } from '@digsup/components-icon';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import listingImg from './assets/listing.png';
import listing2xImg from './assets/listing@2x.png';
import listing3xImg from './assets/listing@3x.png';

export const FeatureListing = () => (
  <FeaturesItem
    title="Off-Market Listings"
    description="Create a custom listing with your estimated future sell date; queue up potential buyers years in advance with zero fees and no listing agreement."
    icon={
      <Icon
        name="house"
        size="xlarge"
        shape="round"
        fill="warm-accent"
        shapeColor="highlight-neutral"
      />
    }
    media={
      <div className="l-homepage-features__listing-media">
        <div className="l-homepage-features__listing-media-img">
          <Image
            src={listingImg}
            srcset={`
              ${listingImg} 438w,
              ${listing2xImg} 876w,
              ${listing3xImg} 1314w
            `}
            sizes="438px"
            placeholderImage=""
            alt="Custom listing"
          />
        </div>
      </div>
    }
  />
);
